import React from "react";
import { NavigationDots, SocialMedia } from "../UI/Navigation";

export const AppWrap = (Component, idName, className) =>
  function HOC() {
    return (
      <div id={idName} className={`app__container ${className}`}>
        <SocialMedia />

        <div className="app__wrapper app__flex">
          <Component />

          <div className="copyright">
            <p className="p-text">@2021 EMANUEL</p>
            <p className="p-text">
              Todos los derechos reservados.{" "}
              <a
                href="https://emanuelmamani.netlify.com/"
                className="p-text"
                target="blank"
              >
                old version
              </a>
            </p>
          </div>
        </div>

        <NavigationDots active={idName} />
      </div>
    );
  };
